import { MapContainer, TileLayer } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import MapController from './MapController';
import AQIMarkers from '../AQIMarkers/AQIMarkers';
import TemperatureLayer from './TemperatureLayer';
import RegionsLayer from './RegionsLayer';
import { REGION_GEOJSON } from '../../data/regions.geojson';

import './Map.scss';

const Map = ({ temperatureLayer, particleLayer, mapRef, highlightedRegion }) => {
  return (
    <MapContainer center={[39.79, -100.53]} zoom={4} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        opacity={1}
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
      />

      <TemperatureLayer temperatureLayer={temperatureLayer} />

      <RegionsLayer data={REGION_GEOJSON} highlighted={highlightedRegion} />

      {particleLayer && <MapController particleLayer={particleLayer} mapRef={mapRef} />}
      <AQIMarkers />
    </MapContainer>
  );
};

export default Map;
